<template>
  <!--
    L'ANNONCE DE FERMETURE.

    ELLE REVIENT À CHAQUE CHARGEMENT, ET C'EST TOUT LE PROPOS. On pourrait
    retenir dans le navigateur qu'elle a déjà été vue — c'est ce que faisaient
    les notes de version — mais une annonce qu'on ne voit qu'une fois est une
    annonce qu'on oublie. Celle-ci doit s'installer dans la tête du joueur
    avant que le site ne ferme pour de bon : elle se referme d'un clic, et elle
    est de retour au rechargement suivant.

    ELLE SE FERME, ET SANS SE FAIRE PRIER : la croix, le bouton, la touche
    Échap, un clic à côté. Rendre une annonce difficile à fermer ne la fait pas
    mieux lire, ça la fait détester.
  -->
  <v-dialog v-model="dialog" max-width="1149px">
    <v-card class="rounded-xl closing-card">
      <v-card-title class="d-flex justify-space-between align-center pa-4">
        <span class="text-h5 text-primary font-weight-bold">Fermeture définitive</span>
        <v-btn icon variant="text" aria-label="Fermer" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!--
        L'IMAGE EST LE MESSAGE, donc elle prend toute la place disponible — et
        c'est la FENÊTRE QUI SE RÈGLE SUR ELLE, pas l'inverse. Une largeur
        imposée aurait laissé deux bandes noires de part et d'autre d'une
        image en hauteur, et autant de place perdue sur un texte qu'il faut
        pouvoir lire.

        Jamais agrandie au-delà de sa définition : `width: auto` avec deux
        maximums laisse le navigateur choisir la plus grande taille qui tient,
        et sur un grand écran c'est la taille native.
      -->
      <v-card-text class="pa-0">
        <img src="/Closed.png" alt="Fermeture définitive" class="closing-image" />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="elevated" @click="dialog = false">
          Fermer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClosingDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    dialog: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style scoped>
/*
  LA CARTE PREND LA LARGEUR DE L'IMAGE, et c'est ce qui supprime les bandes :
  sans `fit-content`, la fenêtre s'étale jusqu'à sa largeur maximale et laisse
  l'image flotter au milieu.
*/
.closing-card {
  width: fit-content;
  max-width: 100%;
  margin-inline: auto;
}

/*
  Les deux cent vingt pixels retirés à la hauteur sont le titre, les actions et
  la marge de la fenêtre : sans eux, le bas de l'annonce passerait sous l'écran.
*/
.closing-image {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: calc(100vh - 220px);
}
</style>
